/*
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2023-02-01 19:15:56
 * @LastEditors: pj
 * @LastEditTime: 2023-02-02 18:38:33
 */
import request from '@/utils/request'

// 首页顶部宣传模块
export function index () {
    return request({
        method: 'get',
        url: 'platform/pc/index',
    })
}

// 首页热门游戏
export function index_game () {
    return request({
        method: 'get',
        url: 'platform/pc/index/game',
    })
}

// 首页游戏专题
export function index_subject () {
    return request({
        method: 'get',
        url: 'platform/pc/index/subject',
    })
}

// 小轮播
export function index_advertise (data) {
    return request({
        method: 'get',
        url: 'platform/pc/index/advertise',
        params: data
    })
}

// 侧栏礼包
export function index_gift (data) {
    return request({
        method: 'get',
        url: 'platform/pc/index/gift',
        params: data
    })
}
// 侧栏游戏推荐【下载】
export function game_recommend () {
    return request({
        method: 'get',
        url: '/platform/pc/game/recommend',
    })
}

// 图片验证码
export function send_captcha (data) {
    return request({
        method: 'get',
        url: '/platform/pc/send/captcha',
        data
    })
}